import { API_URLS } from "../Constants/api.constants";
import api from "./api";
import { errorHandling } from "./error.handling";

const basePath = `${API_URLS.CHIP}/v1/equipment`;

// Migrado pro serviço dedicado de Equipamentos (era hospedado no serviço de
// Chips). Reaproveita o mesmo domínio já usado por equipment.models.service.js.
const NC8_EQUIPMENT = API_URLS.EQUIPMENT.replace("/manufacturer", "");
const equipmentBasePath = `${NC8_EQUIPMENT}/equipment`;

// Campos aceitos pelo POST/PUT da nova API — o retorno do GET traz vários
// outros campos (hardware/software/iccid/imei/apn/ip) que são só leitura.
const buildEquipmentPayload = (payload) => ({
  EquipmentModelId: payload.modelEquipmentId,
  SerialNumber: payload.serial,
  Address: payload.address,
  EquipmentStatusId: payload.statusEquipmentId,
  AccreditedId: payload.accreditedId,
});

async function create(payload) {
  try {
    let response = await api.post(
      equipmentBasePath,
      JSON.stringify(buildEquipmentPayload(payload))
    );
    let treated = errorHandling.handleResponse(
      response,
      "equipmentService.create"
    );
    if (treated) {
      return treated;
    }
    return null;
  } catch (error) {
    errorHandling.cathError(error, "equipmentService.create");
    return null;
  }
}

async function update(payload) {
  try {
    const equipmentId = payload.equipmentId ?? payload.id;
    const body = { Id: equipmentId, ...buildEquipmentPayload(payload) };
    let response = await api.put(
      `${equipmentBasePath}/${equipmentId}`,
      JSON.stringify(body)
    );
    let treated = errorHandling.handleResponse(
      response,
      "equipmentService.update"
    );
    if (treated) {
      return treated;
    }
    return null;
  } catch (error) {
    errorHandling.cathError(error, "equipmentService.update");
    return null;
  }
}

async function save(payload) {
  if (payload.id > 0) {
    payload.equipmentId = payload.id;
    delete payload.id;
    await update(payload);
    return payload.equipmentId;
  }
  return await create(payload);
}

// GET aceita filtros opcionais (EquipmentId/SerialNumber/etc.) — usado pra
// trazer os campos extras somente-leitura (hardware/software/iccid/imei/apn/ip)
// que não fazem parte do payload de POST/PUT.
async function fetchEquipment(filters = {}) {
  try {
    const params = new URLSearchParams();
    if (filters.equipmentId) params.append("EquipmentId", filters.equipmentId);
    if (filters.equipmentModelId) params.append("EquipmentModelId", filters.equipmentModelId);
    if (filters.equipmentStatusId) params.append("EquipmentStatusId", filters.equipmentStatusId);
    if (filters.serialNumber) params.append("SerialNumber", filters.serialNumber);
    if (filters.address) params.append("Address", filters.address);

    const query = params.toString();
    let response = await api.get(`${equipmentBasePath}${query ? `?${query}` : ""}`);
    let treated = errorHandling.handleResponse(
      response,
      "equipmentService.fetchEquipment"
    );
    if (treated) {
      return treated;
    }
    return null;
  } catch (error) {
    errorHandling.cathError(error, "equipmentService.fetchEquipment");
    return null;
  }
}

// GET /api/v3/equipment/status — sem parâmetros, lista os status possíveis
// (EquipmentStatusId, Description, RemoveChip) pra usar no filtro/form.
async function fetchEquipmentStatus() {
  try {
    let response = await api.get(`${equipmentBasePath}/status`);
    let treated = errorHandling.handleResponse(
      response,
      "equipmentService.fetchEquipmentStatus"
    );
    if (treated) {
      return treated;
    }
    return null;
  } catch (error) {
    errorHandling.cathError(error, "equipmentService.fetchEquipmentStatus");
    return null;
  }
}

async function searchBySerial(serial) {
  var payload = {
    pageSize: 500,
    pageNumber: 1,
    serial: serial,
  };

  try {
    let response = await api.post(`${basePath}/serial`, payload);
    let treated = errorHandling.handleResponse(
      response,
      "chipService.searchBySerial"
    );
    if (treated) {
      return treated;
    }
    return null;
  } catch (error) {
    errorHandling.cathError(error, "chipService.searchBySerial");
    return null;
  }
}

async function searchByLineNumber(lineNumber) {
  var payload = {
    pageSize: 500,
    pageNumber: 1,
    lineNumber: lineNumber,
  };

  try {
    let response = await api.post(`${basePath}/lineNumber`, payload);
    let treated = errorHandling.handleResponse(
      response,
      "chipService.searchByLineNumber"
    );
    if (treated) {
      return treated;
    }
    return null;
  } catch (error) {
    errorHandling.cathError(error, "chipService.searchByLineNumber");
    return null;
  }
}

async function listModels() {
  var payload = {
    pageSize: 500,
    pageNumber: 1,
    name: -1,
  };

  try {
    let response = await api.post(`${basePath}/model`, payload);
    let treated = errorHandling.handleResponse(
      response,
      "chipService.listModels"
    );
    if (treated) {
      return treated;
    }
    return null;
  } catch (error) {
    errorHandling.cathError(error, "chipService.listModels");
    return null;
  }
}

async function listAccredited() {
  var payload = {
    pageSize: 500,
    pageNumber: 1,
    name: -1,
  };

  try {
    let response = await api.post(`${basePath}/accredited`, payload);
    let treated = errorHandling.handleResponse(
      response,
      "chipService.listAccredited"
    );
    if (treated) {
      return treated;
    }
    return null;
  } catch (error) {
    errorHandling.cathError(error, "chipService.listAccredited");
    return null;
  }
}

async function listStatus() {
  var payload = {
    pageSize: 500,
    pageNumber: 1,
    name: -1,
  };

  try {
    let response = await api.post(`${basePath}/status`, payload);
    let treated = errorHandling.handleResponse(
      response,
      "chipService.listStatus"
    );
    if (treated) {
      return treated;
    }
    return null;
  } catch (error) {
    errorHandling.cathError(error, "chipService.listStatus");
    return null;
  }
}

export const equipmentService = {
  save,
  fetchEquipment,
  fetchEquipmentStatus,
  searchByLineNumber,
  searchBySerial,
  listModels,
  listAccredited,
  listStatus,
};
